import React from 'react';
import { useTestPlaybookDrawerContext } from 'app/playbook-editor/transform-drawer/TestPlaybookDrawerContextProvider';
import AdvancedOutputTab from 'app/playbook-editor/transform-drawer/DrawerTabsSection/AdvancedOutputTab';

export default function PlaybookOutputTab() {
  const {
    chainState: { playbookOutput },
  } = useTestPlaybookDrawerContext();

  return <AdvancedOutputTab output={playbookOutput} trackingEventName="editor_test_playbook_output_viewed" />;
}
